import React, { useEffect, useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import api from "../../api";

// Phase 4C, §14. Form Type + Published Form pickers, both sourced from
// GET /form-assignment-options/form-types and .../forms — already
// eligibility-filtered server-side (active form/form-type, PUBLISHED
// version only, project/module context match, visibility-scope check).
// Never lets the caller pick a draft version: the form option row IS the
// published version (published_version_id/published_version_number), and
// the backend re-validates the version is published again at assignment-
// creation time regardless.
export default function FormAssignmentFormSelector({
  projectId, projectModuleId, formTypeId, formId,
  onFormTypeChange, onFormChange,
  isDisabled = false,
}) {
  const [formTypes, setFormTypes] = useState([]);
  const [forms, setForms] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(false);
  const [loadingForms, setLoadingForms] = useState(false);

  useEffect(() => {
    let active = true;
    setLoadingTypes(true);
    api
      .get("/form-assignment-options/form-types", { params: { project_id: projectId || undefined, project_module_id: projectModuleId || undefined } })
      .then((res) => { if (active) setFormTypes(Array.isArray(res.data?.data) ? res.data.data : []); })
      .catch((err) => console.error("Fetch assignable form types error:", err))
      .finally(() => { if (active) setLoadingTypes(false); });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, projectModuleId]);

  useEffect(() => {
    let active = true;
    setLoadingForms(true);
    api
      .get("/form-assignment-options/forms", {
        params: {
          project_id: projectId || undefined,
          project_module_id: projectModuleId || undefined,
          form_type_id: formTypeId || undefined,
          pageSize: 200,
        },
      })
      .then((res) => { if (active) setForms(Array.isArray(res.data?.data) ? res.data.data : []); })
      .catch((err) => console.error("Fetch assignable forms error:", err))
      .finally(() => { if (active) setLoadingForms(false); });
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, projectModuleId, formTypeId]);

  const selectedForm = forms.find((f) => String(f.id) === String(formId)) || null;

  return (
    <Row className="g-3">
      <Col md={6}>
        <Form.Label>Form Type</Form.Label>
        <Form.Select value={formTypeId || ""} disabled={isDisabled || loadingTypes} onChange={(e) => onFormTypeChange(e.target.value)}>
          <option value="">{loadingTypes ? "Loading..." : "All form types"}</option>
          {formTypes.map((ft) => (
            <option key={ft.id} value={ft.id}>{ft.name}</option>
          ))}
        </Form.Select>
      </Col>
      <Col md={6}>
        <Form.Label>Published Form</Form.Label>
        <Form.Select
          value={formId || ""}
          disabled={isDisabled || loadingForms}
          onChange={(e) => {
            const id = e.target.value;
            const row = forms.find((f) => String(f.id) === String(id)) || null;
            onFormChange(id, row);
          }}
        >
          <option value="">{loadingForms ? "Loading..." : "Select a published form..."}</option>
          {forms.map((f) => (
            <option key={f.id} value={f.id}>
              {f.name} ({f.form_type_name}) — v{f.published_version_number}
            </option>
          ))}
        </Form.Select>
        {selectedForm && (
          <Form.Text className="text-muted">
            {selectedForm.project_name ? `Scoped to ${selectedForm.project_name}${selectedForm.project_module_name ? ` / ${selectedForm.project_module_name}` : ""}` : "Organization-wide form"}
          </Form.Text>
        )}
      </Col>
    </Row>
  );
}
